import Toast from '../../component/toastify/Index';
import axios from './../../axios/interceptor.js';

export const getClientRequestList = async (payload) => {
    try {
        const response = await axios.post('/client/getClientRequestList')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getClientList = async () => {
    try {
        const response = await axios.post('/client/getClientList')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const confirmClientPayment = async (id) => {
    try {
        const response = await axios.post('/client/confirmClientPayment/' + id)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteClient = async (id) => {
    try {
        const response = await axios.put('/client/deleteClient/' + id, { isDelete: true })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const clientPaymentStatus = async (id, confirm) => {
    try {
        const response = await axios.post(`/client/paymentStatus/${id}`, { confirm })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getPaymentStatusList = async (payload) => {
    try {
        const response = await axios.post('/client/getPaymentStatusList', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const inActiveClient = async (id) => {
    try {
        const response = await axios.put(`/client/inActiveClient/${id}`, { isDelete: false })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const toggleClientStatus = async (id, isDelete) => {
    try {
        const response = await axios.put(`/client/toggleClientStatus/${id}`, { isDelete: isDelete })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}